import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Providers from "./app/providers";
import { I18nProvider } from "./i18n/I18nProvider";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <Providers>
          <I18nProvider>
            <App />
          </I18nProvider>
        </Providers>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);
